import { useQuery } from '@tanstack/react-query';
import { db } from '@services/offline/db';

export const syncQueueQueryKey = ['sync-queue'];

export const useSyncQueue = () =>
  useQuery({
    queryKey: syncQueueQueryKey,
    queryFn: () => db.syncQueue.orderBy('createdAt').reverse().toArray(),
    refetchInterval: 5000
  });
